'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('style-edit', {
      url: '/admin/style/edit',
      template: '<style-edit></style-edit>',
        authenticate: 'superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/~ap/app/styles/edit/style-edit.routes.js